<template lang="pug">
div.av-pill-group-container.av-similar-ai-container(v-if="data?.nearby?.length" :class="{ 'dark': hasDarkClass }")
  div.av-pill-group-content
    Block(v-if="block.innerBlocks[0]?.innerBlocks[0]" :block="block.innerBlocks[0].innerBlocks[0]")
    div.av-pill-group
      a.av-pill(
        v-for="(link, index) in data?.nearby"
        :key="index"
        :href="link.url"
        :class="{ 'dark': !hasDarkClass }")
        span {{ link.name }}
</template>

<script setup lang="ts">
import { useRuntimeConfig, useRoute } from "#app"
import { computed } from "vue"
import { getAttributes } from "~/utils/block"

const config = useRuntimeConfig()
const route = useRoute()
const apiKey = config.public.similarAI.key

const props = defineProps({
  block: {
    type: Object as () => Block,
    required: true
  }
})

//remove trailing slash
const currentPath = route.path.replace(/\/+$/, '')

const hasDarkClass = computed(() => {
  const attributes = getAttributes(props.block)
  return attributes.class?.includes('dark') || false
})

const pillClass = computed(() => {
  return hasDarkClass.value ? 'av-pill' : 'av-pill dark'
})

const headingText = computed(() => {
  try {
    const headingBlock = props.block?.innerBlocks?.[0]?.innerBlocks?.[0];
    if( headingBlock && headingBlock.tagName === 'h2' ) {
      return headingBlock.innerHtml;
    }
  } catch (e) {
    console.error('Error accessing heading block:', e);
  }
  return 'Looking for something else?';
})

const { data, status, error, refresh } = await useFetch(
  'https://isentropic-snow-282609.ew.r.appspot.com/api/seo-related-searches/',
  {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-API-KEY': apiKey
    },
    body: {
      url: 'https://www.anyvan.com' + currentPath
    }
  }
)

</script>

<style>
@import '@anyvan-ui/pill/index.css';
@import '@anyvan-ui/pill-group/index.css';

/* Hide the parent section when SimilarAISection has no content */
section.av-similar-ai-container:has(.content:empty) {
  display: none;
}
</style>
